<template>
<div>

  <!-- View third party modal template -->
  <b-modal id="modal-tabs"
           ref="view-tp"
           hide-footer
           @hide="hideTPModal"
  >

      <div class="d-block text-center">
        <h4 qid="view-tp-title" v-if="object.system">
          {{ $t('activities.system.view.title') }} '{{ object.system.name }}'
        </h4>
        <div v-if="object.system" class="small">
            <span v-if="object.system.validation && object.system.validation.validation === 1">
              <span >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              {{ $t('system.approved') }}
            </span>
            <span v-if="object.system.validation && object.system.validation.validation === 0">
              <span >
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
              {{ $t('system.rejected') }}
            </span>
            <span v-if="object.system.validation && object.system.validation.created_by"
                  class="text-muted font-italic"
            >
              {{ $t('system.by') }}
              <span v-if="object.system.validation.created_by" qid="view-tp-validation-by">
                {{ object.system.validation.created_by.name }}
              </span>
            </span>
            <span v-if="object.system.validation && object.system.validation.updated_at"
                  class="text-muted font-italic"
            >
              {{ $t('system.on') }}
              <span v-if="object.system.validation.created_at" qid="view-tp-validation-date">
                {{ object.system.validation.created_at | formatDate }}
              </span>
            </span>
        </div>
      </div>

      <b-tabs class="mt-3">
        <!-- Basic info tab -->
        <b-tab title="Basic info">
          <div v-if="object.system">
            <br>
            <div v-if="object.processing_role">
              <label>{{ $t('systems.view.processing_role_label') }}</label>
              <p>{{ object.processing_role }}</p>
              <br>
            </div>
            <div v-if="object.system.name">
              <label>{{ $t('systems.create.name_label') }}</label>
              <p>{{ object.system.name }}</p>
              <br>
            </div>
            <div v-if="object.description">
              <label>{{ $t('systems.create.description_label') }}</label>
              <p class="text-formatted">{{ object.description }}</p>
              <br>
            </div>
            <div v-if="object.system_role">
              <label>{{ $t('systems.view.system_role_label') }}</label>
              <p>{{ object.system_role }}</p>
              <br>
            </div>
            <div v-if="object.rules_followed">
              <label>{{ $t('systems.view.rules_followed_label') }}</label>
              <p>
                <span v-if="object.rules_followed && object.rules_followed == 1">
                  {{ $t('system.yes') }}
                </span>
                <span v-if="object.rules_followed && object.rules_followed == 0">
                  {{ $t('system.no') }}
                </span>
              </p>
              <br>
            </div>
            <div v-if="object.system.is_structured || object.system.is_unstructured || object.system.is_physical">
              <label>{{ $t('systems.create.data_structure_label') }}</label>
              <p>
                <span v-if="object.system.is_structured" class="badge badge-info mr-1">
                  {{ $t('systems.table.structured') }}
                </span>
                <span v-if="object.system.is_unstructured" class="badge badge-info mr-1">
                  {{ $t('systems.table.unstructured') }}
                </span>
                <span v-if="object.system.is_physical" class="badge badge-info mr-1">
                  {{ $t('systems.table.physical') }}
                </span>
              </p>
              <br>
            </div>
            <div v-if="object.system.tags_translated && object.system.tags_translated.length">
              <label>{{ $t('systems.create.tags_label') }}</label>
              <p>
                <span class="mr-1 mb-1"
                      v-for="tag in object.system.tags_translated"
                      :key="tag.id"
                      qid="p-tags-list"
                >
                  <span class="badge badge-info mb-1" :title="tag.name_translated">
                    {{ tag.name_translated | truncate(35) }}
                  </span>
                </span>
              </p>
              <br>
            </div>
          </div>
        </b-tab>

        <!-- Data tab -->
        <b-tab title="Data" class="mt-3">
          <div v-if="object.data_objects && object.data_objects.length">
            <label>{{ $t('systems.data_objects.title') }}</label>
            <p>
              <span v-for="dataObject in object.data_objects" :key="dataObject.id">
                <span class="badge badge-info mr-1 mt-1" :title="dataObject.name">
                  {{dataObject.name | truncate(35)}}
                </span>
              </span>
            </p>
            <p v-if="secondaryDO && secondaryDO.length">
              <span v-for="dataObject in secondaryDO" :key="dataObject.id">
                <span class="badge badge-light mr-1 mt-1" :title="dataObject.name">
                  {{dataObject.name | truncate(35)}}
                </span>
              </span>
            </p>
            <br>
          </div>
          <div v-if="object.data_objects && !object.data_objects.length">
            <label v-if="object.system && object.system.data_objects && object.system.data_objects.length">
              {{ $t('systems.data_objects.title') }}
            </label>
            <p v-if="object.system && object.system.data_objects && object.system.data_objects.length">
              <span v-for="dataObject in object.system.data_objects" :key="dataObject.id">
                <span class="badge badge-light mr-1 mt-1">
                  {{dataObject.name}}
                </span>
              </span>
            </p>
            <br>
          </div>
          <div v-if="!object.data_objects">
            <div v-if="object.system">
              <div v-if="object.system.data_objects && object.system.data_objects.length">
                <label>{{ $t('systems.data_objects.title') }}</label>
                <p>
                  <span v-for="dataObject in object.system.data_objects" :key="dataObject.id">
                    <span class="badge badge-info mr-1 mt-1">{{dataObject.name}}</span>
                  </span>
                </p>
                <br>
              </div>
            </div>
          </div>
        </b-tab>


        <!-- Documents tab -->
        <b-tab title="Documents" class="mt-3" :active="active">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="view-system-error"
          >
            {{ error }}
          </b-alert>
          <div v-if="object">
            <p>{{ $t('activities.system.view.documents_description') }}</p>
            <br>
            <div class="mt-1">
              <p class="text-dark">
                {{ $t('attachments.label') }}
                &nbsp;
                <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
              </p>
              <p v-for="(file, index) in object.media">
                <span class="float-right text-muted cursor-pointer"
                      @click="showFileModal(file, index)"
                      qid="remove-media-item"
                      v-if="isGranted([permissions.ACTIVITY_SYSTEM_EDIT, permissions.ACTIVITY_SYSTEM_EDIT_OWN], object.activity) ||
                      isGranted([permissions.ACTIVITY_SYSTEM_EDIT, permissions.ACTIVITY_SYSTEM_EDIT_OWN], object.activity)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <span class="mr-3 float-right text-muted cursor-pointer"
                      @click="downloadMedia(file)"
                      qid="download-media"
                >
                  <font-awesome-icon icon="cloud-download-alt" />
                </span>
                <a @click="downloadMedia(file)" qid="create-tp-media-item">
                  {{ file.file_name }}
                </a>
              </p>
              <label class="btn btn-secondary cursor-pointer"
                     qid="create-tp-file-button"
                     v-if="isGranted([permissions.ACTIVITY_SYSTEM_EDIT, permissions.ACTIVITY_SYSTEM_EDIT_OWN], object.activity) ||
                     isGranted([permissions.ACTIVITY_SYSTEM_EDIT, permissions.ACTIVITY_SYSTEM_EDIT_OWN], object.activity)"
              >
                <input type="file"
                       name="fileupload"
                       value="fileupload"
                       multiple
                       id="file"
                       @change="onFileChange"
                       @click="resetFile"
                >
                <span>
                  <font-awesome-icon icon="cloud-upload-alt" />
                  {{ $t('attachments.upload_button') }}
                </span>
              </label>
              <br>
            </div>
            <div class="mt-4 mb-4">
              <p class="text-dark">{{ $t('links.label') }}</p>

              <div v-if="object.links">
                <p v-for="(link, index) in object.links" >
                  <span class="float-right text-muted cursor-pointer"
                        @click="showLinkModal(link, index)"
                        qid="view-tp-remove-link"
                        v-if="isGranted([permissions.ACTIVITY_SYSTEM_EDIT, permissions.ACTIVITY_SYSTEM_EDIT_OWN], object.activity) ||
                        isGranted([permissions.ACTIVITY_SYSTEM_EDIT, permissions.ACTIVITY_SYSTEM_EDIT_OWN], object.activity)"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-tp-link-item">
                    {{ link.name ? link.name : link.url }}
                  </a>
                </p>
              </div>
              <div v-if="showInput">
                <label class="mt-2">{{ $t('system.link') }}</label>
                <b-form-input
                  type="text"
                  aria-describedby="inputGroup"
                  v-model="inputLink"
                  :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                  qid="create-p-links"
                ></b-form-input>
                <label class="mt-2">{{ $t('table.name') }}</label>
                <b-form-input
                  type="text"
                  aria-describedby="inputGroup"
                  v-model="inputLinkName"
                  :placeholder="inputLink ? inputLink : $t('table.name')"
                  qid="create-p-links"
                ></b-form-input>
                <div class="text-right mt-2">
                  <span class="btn btn-success cursor-pointer mr-0"
                        id="inputGroup"
                        @click="handleLink"
                        qid="handle-link-save"
                  >
                    {{ $t('system.save') }}
                  </span>
                </div>
              </div>
              <span v-if="isGranted([permissions.ACTIVITY_SYSTEM_EDIT, permissions.ACTIVITY_SYSTEM_EDIT_OWN], object.activity) ||
              isGranted([permissions.ACTIVITY_SYSTEM_EDIT, permissions.ACTIVITY_SYSTEM_EDIT_OWN], object.activity)">
                <span class="btn btn-link cursor-pointer"
                      @click="showInput = true"
                      qid="add-another-link"
                >
                  <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
                </span>
              </span>
              <br>
            </div>
          </div>
        </b-tab>

        <b-button class="float-right"
                  variant="success"
                  @click="hideTPModal"
                  qid="create-p-cancel-button"
        >
          {{ $t('processes.policies.view.close') }}
        </b-button>
        <br>
      </b-tabs>
  </b-modal>

  <!-- Delete attachment modal -->
  <b-modal ref="delete-attachment-modal" hide-footer>
    <div class="d-block text-center">
      <h4 qid="delete-s-title">
        {{ $t('attachments.delete.title') }}
      </h4>
    </div>
    <h5 class="text-center">
      <span>
        {{ $t('attachments.delete.are_you_sure_file') }}
      </span>
    </h5>
    <div class="text-center">
      <b-button class="mt-3"
                variant="secondary"
                @click="hideFileModal"
                qid="delete-attachment-cancel-button"
      >
        {{ $t('attachments.delete.cancel') }}
      </b-button>
      <b-button @click="removeMediaItem(selectedFileObject, selectedFileIndex)"
                class="mt-3 ml-3"
                variant="danger"
                qid="delete-attachment-submit-button"
      >
        {{ $t('attachments.delete.submit') }}
      </b-button>
    </div>
  </b-modal>

  <!-- Delete link modal -->
  <b-modal ref="delete-link-modal" hide-footer>
    <div class="d-block text-center">
      <h4 qid="delete-s-title">
        {{ $t('attachments.delete.title') }}
      </h4>
    </div>
    <h5 class="text-center">
      <span>
        {{ $t('attachments.delete.are_you_sure_link') }}
      </span>
    </h5>
    <div class="text-center">
      <b-button class="mt-3"
                variant="secondary"
                @click="hideLinkModal"
                qid="delete-link-cancel-button"
      >
        {{ $t('attachments.delete.cancel') }}
      </b-button>
      <b-button @click="removeLink(selectedLinkObject, selectedLinkIndex)"
                class="mt-3 ml-3"
                variant="success"
                qid="delete-link-submit-button"
      >
        {{ $t('attachments.delete.submit') }}
      </b-button>
    </div>
  </b-modal>

</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'SystemViewModal',
    data: function() {
      return {
        error: '',
        showInput: false,
        loadingItems: false,
        showArticleDescription: false,
        secondaryDO: [],
        inputLink: '',
        inputLinkName: '',
        selectedFileObject: {},
        selectedFileIndex: '',
        selectedLinkObject: {},
        selectedLinkIndex: '',
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      },
      active: {
        type: Boolean
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getMedia() {
        return this.object.media
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showTPModal()
        }
      }
    },
    methods: {
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      showFileModal(object, index) {
        let self = this
        this.selectedFileObject = object;
        this.selectedFileIndex = index;
        this.$refs['delete-attachment-modal'].show()
      },
      hideFileModal() {
        this.$refs['delete-attachment-modal'].hide()
      },
      showLinkModal(object, index) {
        let self = this
        this.selectedLinkObject = object;
        this.selectedLinkIndex = index;
        this.$refs['delete-link-modal'].show()
      },
      hideLinkModal() {
        this.$refs['delete-link-modal'].hide()
      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      handleLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLink.startsWith('http')) {
          this.inputLink = 'http://' + this.inputLink
        }

        formData.append("url", this.inputLink);
        formData.append("name", this.inputLinkName);
        formData.append("model_type", this.object.who_am_i);
        formData.append("model_id", this.object.id);

        piincHttp.post('links', formData).then(function(response) {
          self.$toastr('success', self.$t('processes.legal_basis.link_add_success'))
          self.object.links = response.data.links
          self.inputLink = ''
          self.inputLinkName = ''
          self.showInput = false
        }, function() {})
      },
      removeLink(object, index) {
        let self = this;
        piincHttp.delete('links/'+object.id).then(function() {
          self.object.links.splice(index, 1);
          self.hideLinkModal();
          self.$toastr('success', self.$t('processes.legal_basis.link_delete_success'))
        }, function() {})
      },
      removeMediaItem(object, index) {
        let self = this;
        piincHttp.delete('documents/'+ object.id).then(function() {
          self.object.media.splice(index, 1);
          self.hideFileModal();
          self.$toastr('success', self.$t('processes.legal_basis.media_delete_success'))
        }, function() {})
      },
      onFileChange(file) {
        let files = file.target.files;
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        for (var i = 0; i < files.length; i++) {
          // Equal to 10 MB
          if (files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append('document[]', files[i]);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.object.who_am_i);
        formData.append("model_id", this.object.id);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('processes.legal_basis.media_add_success'))
            self.error = ''
            self.object.media = response.data.media
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
      showTPModal() {
        let self = this;
        this.secondaryDO = []
        let inArray = false;

        if (this.object.data_objects && this.object.data_objects.length) {
          if (this.object.system.data_objects && this.object.system.data_objects.length) {
            _.forEach(this.object.system.data_objects, function (dataObject) {
              inArray = false;
              _.forEach(self.object.data_objects, function (item) {
                if (item.id == dataObject.id) {
                  // if item is already in array
                  inArray = true;
                }
              })
              if (!inArray) {
                // If not in array, push it in array as related
                self.secondaryDO.push(dataObject)
              }
            })
          }
        }
        this.$refs['view-tp'].show()
      },
      hideTPModal() {
        this.error = ''
        this.showArticleDescription = false;
        this.showInput = false;
        this.$emit('closeViewModal');
        this.$refs['view-tp'].hide()
      }
    },
    components: {

    },
    created () {

    }
  }
</script>
